import { useEffect, useState } from 'react';

import { ScanAnalyticsData } from '../../../../interfaces/entity-dashboard/ScanAnalyticsData';
import { entityDashboardService } from '../../../../services/entityDashboardService';
import { getDateRangeByPreset } from '../../../../../shared/utils/getDateRangeByPreset/getDateRangeByPreset';
import { DateRangePreset } from '../../../../../shared/constants/dateRangePreset';
import { SolutionTypeFilter } from '../../../../../shared/constants/user-info/solutionType';

type UseScanAnalyticsDataParams = {
  dateRangePreset: DateRangePreset;
  solutionTypeFilter: SolutionTypeFilter;
};

type UseScanAnalyticsDataReturn = {
  scanAnalyticsData: ScanAnalyticsData | null;
};

export const useScanAnalyticsData = ({
  dateRangePreset,
  solutionTypeFilter,
}: UseScanAnalyticsDataParams): UseScanAnalyticsDataReturn => {
  const [scanAnalyticsData, setScanAnalyticsData] = useState<ScanAnalyticsData | null>(
    null,
  );

  const fetchScanAnalyticsData = async () => {
    const dateRange = getDateRangeByPreset(dateRangePreset);

    const data = await entityDashboardService.getScanAnalyticsData({
      ...dateRange,
      solutionType: solutionTypeFilter,
    });

    setScanAnalyticsData(data);
  };

  useEffect(() => {
    fetchScanAnalyticsData();
  }, [dateRangePreset, solutionTypeFilter]);

  return { scanAnalyticsData };
};
